import { useState, useEffect } from 'react';

const THEMES = ['light', 'dark', 'ocean', 'forest', 'warm'];

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('pch-theme') || 'ocean';
    }
    return 'ocean';
  });

  useEffect(() => {
    const root = document.documentElement;
    // Remove all theme classes
    THEMES.forEach(t => root.classList.remove(t, 'dark'));
    // Apply current theme
    if (theme === 'dark') {
      root.classList.add('dark');
    } else if (theme !== 'light') {
      root.classList.add(theme);
    }
    root.setAttribute('data-theme', theme);
    localStorage.setItem('pch-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');

  return { theme, setTheme, toggleTheme, THEMES };
}